import HomeCrousalCard from "../cards/Home-crousal-card.tsx";
import { content } from "../../data.tsx";
import "./carousel.css";
import { useRef } from "react";

const HomeCrousal = () => {
  const carousel = useRef<HTMLDivElement>();

  const GoNext = () => {
    if (carousel.current) {
      carousel.current.scrollBy({
        left: carousel.current.clientWidth,
        behavior: "smooth",
      });
    }
  };

  const GoPrev = () => {
    if (carousel.current) {
      carousel.current.scrollBy({
        left: -carousel.current.clientWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="relative w-full py-12">
      <div className="text-center mb-8 px-4">
        <span className="text-blue text-xs font-medium tracking-widest uppercase">Testimonials</span>
        <h3 className="font-display text-2xl lg:text-4xl font-semibold tracking-tight text-lightBlack mt-2">
          Loved by professionals worldwide
        </h3>
      </div>
      <div className="w-[95%] mx-auto carousel-container" ref={carousel}>
        <div className="carousel-inner py-4">
          {content.crasual.map((item, index) => (
            <div key={index} className="w-[40%] flex carousel-item">
              <HomeCrousalCard heading={item.head} imgurl2={item.imgUrl2} />
            </div>
          ))}
        </div>
      </div>

      <div className="w-[100%] flex items-center justify-between absolute top-[58%] translate-y-[-50%] px-2 lg:px-6 pointer-events-none">
        <button
          className="h-11 w-11 bg-white border border-gray-100 hover:border-blue/40 hover:text-blue text-lightBlack flex items-center justify-center rounded-full shadow-soft hover:shadow-card transition-all duration-200 pointer-events-auto"
          onClick={GoPrev}
          aria-label="Previous"
        >
          &#10094;
        </button>
        <button
          className="h-11 w-11 bg-white border border-gray-100 hover:border-blue/40 hover:text-blue text-lightBlack flex items-center justify-center rounded-full shadow-soft hover:shadow-card transition-all duration-200 pointer-events-auto"
          onClick={GoNext}
          aria-label="Next"
        >
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default HomeCrousal;
